import Select from '../../ui/Select.vue';
import axios from 'axios';
import { useField } from 'vee-validate';
import { ref, onMounted } from 'vue';


export default {
  __name: 'ContraceptionMedicineField',
  setup(__props, { expose }) {
  expose();

const contraceptionOptions = ref([]);

const { value, errorMessage, setValue } = useField('contraceptionMedicine');

onMounted(() => {
    axios.get(`${jsData.siteUrl}/wp-json/doctor/v1/contraception-options`).then((response) => {
        contraceptionOptions.value = response.data;
        console.log(response.data);
    });
});

const __returned__ = { contraceptionOptions, value, errorMessage, setValue, Select, get axios() { return axios }, get useField() { return useField }, ref, onMounted }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}